module.exports = __webpack_public_path__ + "img/push.8aeaeed3.jpg";